import React from 'react';
import { fmtMoney } from '../../utils/money';
import { fmtDate } from '../../utils/dates';

// جدول تحويلات الرصيد بين العقود (من → إلى، المبلغ، المرجع/التوجيه).
export default function TransfersPanel({ transfers }) {
  if (!transfers?.length) return null;

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div className="card-title" style={{ marginBottom: 12 }}>تحويلات الرصيد ({transfers.length})</div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr><th>من عقد</th><th>إلى عقد</th><th>المبلغ</th><th>التاريخ</th><th>المرجع / التوجيه</th></tr>
          </thead>
          <tbody>
            {transfers.map((t) => (
              <tr key={t.id}>
                <td>{t.from_title || '—'}</td>
                <td>{t.to_title || <span style={{ color: 'var(--text-muted)' }}>سداد / سحب</span>}</td>
                <td style={{ fontWeight: 600 }}>{fmtMoney(t.amount)}</td>
                <td>{t.transfer_date ? fmtDate(t.transfer_date) : '—'}</td>
                <td style={{ fontSize: 12 }}>{t.note || t.reference || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
